export const environment = {
  production: true,
  api: 'https://abtwwrc00g.execute-api.ap-southeast-2.amazonaws.com/dev/api',
  cognito: {
    userPoolId: 'ap-southeast-2_4kziDHpDG',
    userPoolWebClientId: '4mfq6gkd8ipo0n79jjlkv59lql'
  }
};
